import { StylelessList, type StylelessListProps } from '../../helpers';

type OverflowMenuListProps = StylelessListProps;

export const OverflowMenuList = (props: OverflowMenuListProps) => (
  <StylelessList {...props} />
);
